import React, { useState } from 'react';
import { stylizeKeyword } from 'others/keywords/keywordstyles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import RolesGroup from 'components/RolesGroup/RolesGroup';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function DiscardRole({ open, handleNo, handleYes, selectedRole }) {
    const title = stylizeKeyword("Voulez-vous enlever un jeton [role] du jeu ?");
    const description = stylizeKeyword("Le premier joueur après le [GodFather] peut enlever un jeton [role] pour que le joueur "
                                        + "suivant ne puisse pas déduir qui vous êtes.");

    const [roleToDiscard, setRoleToDiscard] = useState(null);

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
        >
            <DialogTitle id="alert-dialog-slide-title">
                <span dangerouslySetInnerHTML={{__html: title}} />
            </DialogTitle>
            <DialogContent>
                <p dangerouslySetInnerHTML={{ __html: description }}/>
                <h3>Sélectionnez un jeton :</h3>
                <RolesGroup
                    roleToUse={selectedRole}
                    selectedRole={roleToDiscard?.role}
                    showItemConter={false}
                    onRoleSelected={setRoleToDiscard}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleNo} color="secondary">
                    Non
                </Button>
                <Button onClick={()=>handleYes(roleToDiscard?.role)} color="secondary">
                    Oui
                </Button>
            </DialogActions>
      </Dialog>
    );
}

export default DiscardRole;